import { makeStyles } from '@material-ui/core/styles';
import { borderRadius } from '../../../../styles/themes/vad/borderRadius';
import { pxToRem } from '../../../../styles/themes/vad/constants';
import { palette } from '../../../../styles/themes/vad/palette';
import {
  EVENT_TYPE,
} from '../../../../constants';
export default makeStyles(theme => ({
  heartWrap: {
    position: 'relative',
    zIndex: 10,
    cursor: 'pointer',
  },
  absoluteHeartWrap: {
    position: 'absolute',
    zIndex: 10,
    cursor: 'pointer',
    ...theme.mixins.right(0),
  },
  is3DMap: {
    position: 'relative',
    zIndex: 0,
  },
  circularHeartWrap: {
    position: 'relative',
    zIndex: 10,
    cursor: 'pointer',
    width: '20px',
    height: '28px',
    [theme.breakpoints.down('md')]: {
      width: '28px',
      marginTop: '6px',
      borderRadius: '50%',
      background: '#E4E8EA',
      ...theme.mixins.marginRight('6px'),
    }
  },
  MapFavBtn: {
    padding: `${pxToRem(10)} ${pxToRem(17)} !important`,
    boxShadow: 'none',
    height: pxToRem(40),
    backgroundColor: "#F7F7F7",
    border: "1px solid #E9E9E9",
    minWidth: pxToRem(155),
    '@media (min-width: 1440px)': {
      padding: `${pxToRem(10)} ${pxToRem(9.5)} !important`,
    },
    '& .MuiButton-endIcon': {
      overflow: 'visible !important',
    },
    '@media (min-width: 1024px)': {
      ...theme.mixins.marginRight(pxToRem(8)),
      padding: `${pxToRem(10)} ${pxToRem(8.9)} !important`,
      minWidth: "auto",
      justifyContent: 'flex-end',
      width: pxToRem(40),
      overflow: "hidden",
      maxWidth: "fit-content",
      transition: 'all 0.35s linear',

      '& .btn-txt': {
        textWrap: 'nowrap',
      },
      '&:not(.visited)': {
        '&:hover': {
          padding: `${pxToRem(10)} ${pxToRem(16)} !important`,
          transition: 'all 0.35s linear',
          width: (props) => props.favButtonFinalWidth,
        },
      },
    },
    '&:hover': {
      backgroundColor: "#F7F7F7",
    },
    '&.visited': {
      backgroundColor: "rgba(255, 135, 7, 0.15)",
      border: "1px solid rgba(255, 135, 7, 0.15)",
      '& .material-icons': {

        '& path': {
          stroke: "rgba(255, 135, 7, 1)",
          fill: "rgba(255, 135, 7, 1)",
        },
      },
    },
    '& .material-icons': {
      display: 'flex',
      alignItems: 'center',
      width: '100%',
      height: '100%',
      animationName: "none !important",
      '& svg': {
        width: pxToRem(20),
        height: pxToRem(18),
      },
      '& path': {
        stroke: "black",
        fill: "#F7F7F7",
        strokeWidth: 2,
      },
    },
    '& .btn-txt': {
      color: "#000",
      fontSize: pxToRem(12),
      fontWeight: '400',
      lineHeight: pxToRem(16),
      fontFamily: theme.custom.fontFamily.primaryRegular
    },
    '& .MuiButton-label': {
      flexDirection: 'row-reverse',
      '& .MuiButton-endIcon': {
        ...theme.mixins.marginLeft(0),
        ...theme.mixins.marginRight(9),
      },

    }
  },

  mapHeartIcon: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '28px',
  },
  heartIcon: {
    position: 'absolute',
    top: 0,
    ...theme.mixins.right(0),
    marginTop: 19,
    ...theme.mixins.marginRight(18),
    '& svg': {
      width: '20px',
      height: '18px',
    },
  },
  sliderHeartIcon: {
    position: 'absolute',
    top: 0,
    ...theme.mixins.right(0),
    marginTop: 28,
    ...theme.mixins.marginRight(18),
    '& svg': {
      width: '20px',
      height: '18px',
    },
  },
  heartNavIcon: {
    position: 'absolute',
    top: 0,
    ...theme.mixins.right(0),
    ...theme.mixins.marginRight(-2),
    '& svg': {
      width: '20px',
      height: '18px',
    },
  },
  addToFavWrapperDescMin: {
    height: '40px',
    display: 'flex',
    alignItems: 'center',
    ...theme.mixins.marginRight(18),
    [theme.breakpoints.down('md')]: {
      ...theme.mixins.marginRight(12),
      boxSizing: 'content-box',
    },
  },
  addToFavWrapperDesc: {
    height: '40px',
    display: 'flex',
    alignItems: 'center',
    ...theme.mixins.marginRight(18),

    [theme.breakpoints.down('md')]: {
      ...theme.mixins.marginRight(12),
      paddingBottom: pxToRem(24),
      boxSizing: 'content-box',
    },
  },
  addToFavIconWrapDesc: {
    width: '2.5rem',
    height: '2.5rem',
    display: 'flex',
    borderRadius: borderRadius.circle,
    alignItems: 'center',
    background: palette.background.BGGray179(200),
    justifyContent: 'center',
  },
  descHeartIcon: {
    position: 'relative',
    top: 0,
    verticalAlign: 'middle',
    alignItems: 'center',
    height: '18px',
    marginTop: 0,
    '& svg': {
      width: '20px',
      height: '18px',
    },
  },
  heartIconSelected: {
    '& svg': {
      '& path': {
        fill: ({ contentType }) => contentType === EVENT_TYPE && theme.mixins.DarkTurquoise(),
      },
    },
  },
  addToFavText: {
    opacity: 0,
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    color: ({ contentType }) => contentType === EVENT_TYPE ? theme.mixins.DarkTurquoise() : theme.mixins.AbuDhabiOrange(),
    whiteSpace: 'nowrap',
  },
  showFavText: {
    opacity: 1,
  },
  '@global': {
    '.addToFavTextInStickyTitle': {
      height: '100%',
      position: 'relative',
      ...theme.mixins.marginLeft(16),
    },
    '.sticky:not(.ghostdiv-reached)': {
      '& .hideFavText': {
        '& .addToFavTextInStickyTitle': {
          display: 'none',
        },

        '& .ml4': {
          ...theme.mixins.marginLeft(pxToRem(4)),
        },
      },
    },
  },
}));
